import React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="container my-5">
      <div className="row">
        <div className="col-lg-10 col-xl-9 mx-auto">

          <h1 className="mb-3">Artetra Privacy Policy</h1>
          <p className="mb-4">Last updated: 10.04.2026</p>

          <p>
            This Privacy Policy explains how Artetra (&apos;we&apos;, &apos;us&apos;, or &apos;our&apos;) collects, uses, and protects the personal data of users (&apos;you&apos;) who access and use the Artetra platform , as well as the processing activities regarding the personal data carried by Us  on the occasion of providing Our services, including but not limited to virtual gallery generation and API Import functionalities (hereinafter &quot;Services&quot;).
          </p>

          <p>
            We will process all personal data collected from You or which You may provide to Us in compliance with the General Data Protection Regulation (EU) 2016/679 (GDPR), the ePrivacy Directive (2002/58/EC), and the applicable Romanian legal framework.
          </p>

          <hr className="my-4" />

          <section className="mb-4">
            <h2 className="h4">1. Data Controller</h2>
            <p>
              Artetra, a platform developed by NFT MUSE SRL, a company incorporated under the laws of Romania, having its registered office located at Grigore T. Popa 81, Ap 11, Timișoara, Romania, is the personal data controller responsible for processing your personal data.
            </p>
            <p>If you have any questions or requests regarding this policy, please contact us at:</p>
            <p className="mb-1">Email: info@artetra.com</p>
            <p>
              Website: www.artetra.io ; www.museum-artetra.com
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h4">2. Personal Data We Collect</h2>
            <p>
              The processing of personal data represents any type of operation that is carried out on personal data, whether automatic or not, including the collection, registration, storage, and provision of the following categories:
            </p>
            <ul>
              <li>
                <strong>Account data</strong> (name, email, organization, and login credentials, including API keys or public addresses used for synchronization).
              </li>
              <li>
                <strong>Uploaded content</strong> (artworks, images, 3D models, and related metadata associated with digital cultural assets.).
              </li>
              <li>
                <strong>Usage data</strong> (session activityinteractions with galleries, and preferences), clickstream data (the sequence of pages You visit), IP address, browser type, and interactions with virtual galleries.
              </li>
              <li>
                <strong>Analytics and telemetry data</strong> (page views, gallery visits, artwork views, anonymous session identifiers, authenticated user linkage from the same browser session, referrer information, and basic client metadata used for product analytics and platform improvement).
              </li>
              <li>
                <strong>Communication data</strong> (messages between exhibitors and visitors, messages and enquiries sent through the Platform&apos;s integrated Enquiry system or otherwise provided in the context of feedback.
              </li>
              <li>
                <strong>Payment data</strong> (handled by third-party providers securely). Artetra does not store sensitive financial credentials on its own servers.
              </li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h4">3. How We Use Your Data</h2>
            <p>We use your data for the following purposes:</p>
            <ul>
              <li>To provide and maintain the Artetra platform and its technological infrastructure..</li>
              <li>To manage user accounts and authentication and ensure secure authentication for digital exhibits.</li>
              <li>To facilitate communication between exhibitors and visitors and to monitor the Enquiry system for security purposes.</li>
              <li>To improve our services and user experience through technical analysis and session monitoring.</li>
              <li>To measure page, gallery, and artwork engagement through first-party telemetry and analytics reporting.</li>
              <li>To send service updates or notifications when necessary.</li>
              <li>To ensure the security of the Platform and prevent cyber-attacks, pursuant to Directive 2013/40/EU.</li>
              <li>To comply with legal obligations, specifically reporting requirements under Regulation (EU) 2022/2065 (Digital Services Act).</li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h4">4. Legal Basis for Processing</h2>
            <p>We process your data under the following lawful bases:</p>
            <ul>
              <li><strong>Contractual necessity</strong> – to provide the services you register for and to manage the technical interoperability of Artworks.</li>
              <li><strong>Legitimate interest</strong> – to improve and secure our platformand to provide aggregated, anonymized usage statistics to our partners</li>
              <li><strong>Consent</strong> – for optional communications or newsletters, which can be withdrawn at any time.</li>
              <li><strong>Legal compliance</strong> – to meet EU or national legal requirements EU acquis/ rules requirements, including fiscal laws and the Digital Services Act..</li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h4">5. Data Sharing</h2>
            <p>We do not sell or rent personal data. Data may be shared with:</p>
            <ul>
              <li>Hosting and infrastructure partners under strict confidentiality agreements.</li>
              <li>Payment processors for secure billing operations.</li>
              <li>Public authorities when legally required.</li>
              <li><strong>Partners:</strong> aggregated and anonymized data may be shared with the partners that facilitated Your access for impact reporting.</li>
              <li><strong>Public authorities:</strong> When legally bound to do so under Regulation (EU) 2022/2065 or upon a valid request from Romanian judicial authorities.</li>
              <li><strong>Analytics processors:</strong> We may mirror selected telemetry events to trusted analytics service providers acting on Our behalf for product analytics and service quality monitoring.</li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h4">6. Data Retention and Security</h2>
            <p>
              We store personal data on secure servers within the European Union. Data is retained only for as long as necessary to provide our services or for the establishment, exercise, or defense of legal claims.
            </p>
            <p>
              We have implemented appropriate technical and organizational measures (including encryption of data in transit and at rest) to prevent unauthorized access, logic bombs, or other harmful materials, in line with Directive 2013/40/EU.
            </p>
            <p>
              We apply technical and organizational measures to prevent unauthorized access, misuse, or loss.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h4">7. Your Rights</h2>
            <p>Under GDPR, you have the following rights:</p>
            <ul className="list-unstyled">
              <li className="mb-3">
                <strong>The right to access your personal data:</strong>
                You have the right to be informed, upon request, if Your personal data is being processed, and if so, You have the right to request access to it. The information will include but is not limited to, the purposes of the processing, the categories of personal data processed and the recipients or categories of recipients to whom Your personal data has been or will be transmitted.
                You have the right to obtain a copy of the personal data processed.
              </li>
              <li className="mb-3">
                <strong>The right to rectification:</strong>
                You have the right to obtain from Us the rectification of Your incorrect personal data.
              </li>
              <li className="mb-3">
                <strong>The right of erasure (&quot;right to be forgotten&quot;):</strong>
                You have the right to ask Us to delete your personal data.
              </li>
              <li className="mb-3">
                <strong>The right of restriction:</strong>
                You have the right to request a restriction on the processing of Your personal data. In this case, the data will be marked and may be processed by Us only for certain purposes.
              </li>
              <li className="mb-3">
                <strong>The right to data portability:</strong>
                You have the right to receive the personal data that You have provided to Us, in a structured, common, and computer-readable format, and You have the right to transfer this data to another entity without objections from Us.
              </li>
              <li className="mb-3">
                <strong>The right of opposition:</strong>
                You have the right to object, for reasons related to Your situation, at any time, to the processing of Your personal data by Us, and You can ask Us not to process Your personal data. If you have the right to object and exercise it, We will no longer process Your personal data for that purpose, unless the processing of Your personal data is necessary for the performance of a Task already ordered on the Marketplace.
              </li>
            </ul>
            <p>
              If You have any questions regarding the processing of Your personal data or if You would like to make a request to Us or exercise any of Your rights regarding the processing of Your personal data, please contact Us at info@artetra.com.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h4">8. Cookies</h2>
            <p>
              The personal data is collected by Us when You are using the Platform via technology through Cookies. The Platform uses Cookies in order to offer the visitors a better experience when browsing the Platform, as well as to provide services adapted to the needs and interests of its users. In addition, Cookies offer Us important feedback on the way visitors browse the Platform, so that the Platform may be more efficient and more accessible.
            </p>
            <p>
              A Cookie is a small text file made up of letters and numbers that will be stored on the user&apos;s computer, mobile terminal or other device from which the user accesses the Platform. The Cookie is installed by a request made by a web server to a browser (e.g. Google Chrome, Safari), it does not contain software, viruses or spyware and it cannot access information from the user&apos;s hard drives.
            </p>
            <p>
              Cookies are a central point of efficient Internet operation, helping generate a friendly browsing experience that is adapted to the preferences and interests of every user. If Cookies are deactivated, this may render certain Platform functionalities impossible to use.
            </p>
            <p>
              We are using Cookies in order to improve the navigation experience. To this end, Cookies render possible user&apos;s terminal recognition, user preference storage and facilitate the presentation of content in a relevant manner, which is adapted to user preferences.
            </p>
            <p>
              Information, collected automatically by Us on each visit Our Platform:
            </p>
            <ul>
              <li>technical information, including the Internet Protocol (IP) address used to connect Your device to the Internet, browser type and version, time zone setting, browser plug-in types and versions, operating system and platform;</li>
              <li>information about the visits, including the full Uniform Resource Locators (URL), clickstream to, through and from Our Platform (including date and time), services/pages viewed or searched for, page response times, download errors, length of visits to certain pages, page interaction information (such as scrolling, clicks, and mouse-overs), methods used to browse away from the page.</li>
            </ul>
            <p>
              We also operate first-party product analytics on the Platform. This includes recording page views, gallery views, and artwork views, together with anonymous session identifiers and, when You authenticate in the same browser, linking prior same-browser activity to Your account so that We can understand how the Platform is used and improve it.
            </p>
            <p>
              To support internal reporting and product analysis, these first-party analytics events may also be mirrored to third-party analytics processors such as PostHog. Our own backend remains the authoritative source of analytics records used by the Artetra admin dashboard.
            </p>
            <p>
              Please note that a visit on Our Platform can place the following types of Cookies on Your terminal:
            </p>
            <p>
              <strong>Strictly Necessary Cookies</strong> - these Cookies are necessary for the Platform to function and cannot be switched off in our systems. They are usually only set in response to actions made by You that amount to a request for services, such as setting Your privacy preferences or logging into Your Exhibitor profile. You can set Your browser to block or alert You about these Cookies, but some parts of the Platform will not then work.
            </p>
            <p>
              <strong>Performance Cookies</strong> - these Cookies allow Us to count visits and traffic sources so We can measure and improve the performance of Our Platform. They help Us to know which pages are the most and least popular and see how visitors move around the Platform. All information these Cookies collect is aggregated and therefore anonymous. If You do not allow these Cookies We will not know when You have visited Our Platform, and will not be able to monitor its performance.
            </p>
            <p>
              <strong>Functional Cookies</strong> - these Cookies enable the Platform to provide enhanced functionality and personalization. They may be set by Us or by third-party providers whose services We have added to Our Platform. If You do not allow these Cookies then some or all of these services may not function properly.
            </p>
            <p>
              <strong>Third-party analytics services:</strong> In addition to Our Cookies, please note We may use third-party analytics processors to receive mirrored product-analytics events for reporting and service quality analysis.
            </p>
            <p>The Cookies We use are as follows:</p>
            <ul>
              <li><strong>Consent cookie</strong> (Necessary Cookie) - to choose whether to show the cookie popup or not.</li>
              <li><strong>Analytics identifiers</strong> (Performance / analytics storage) - to maintain anonymous session identifiers, same-browser account linkage after authentication, and page/gallery/artwork telemetry used for product analytics and platform improvement.</li>
            </ul>
            <p>
              <strong>Cookies deletion:</strong> Generally, an app used to access web pages implicitly allows Cookie saving on the terminal. These settings can be changed in such a way that the automated management of Cookies is blocked by the web browser or the user is informed each time Cookies are sent to his terminal. Detailed information on the possibilities and manners of managing Cookies can be found in the settings area of the app (web browser) and they vary depending on the type of browser that is used. Please note that any limitation of Cookies use may affect certain Platform functionalities.
            </p>
            <p>
              For more information on Cookies and how You can activate/deactivate them, You can access the following website <a href="https://www.aboutcookies.org/" target="_blank" rel="noopener noreferrer">https://www.aboutcookies.org/</a> or You can check out the Help section from Your web browser. If the visitors do not wish to have Cookies placed on their devices, they should set their browsers to refuse cookies before using the Platform, with the drawback that certain features of the Platform may not function properly without the aid of Cookies.
            </p>
            <p>
              Please note that, if the Cookies that are strictly necessary for the Platform operation are blocked, this may render the Platform impossible to use. If the visitors have not set their browsers to refuse Cookies, then the visitors can delete the Cookies after the visit of the Platform, by accessing the corresponding settings in their web browser. In this case, their data will no longer be processed until their next visit of Our Platform.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h4">9. Legal Disclosure</h2>
            <p>
              Notwithstanding anything to the contrary in this document, We may preserve or disclose Your information if We believe that it is reasonably necessary to comply with a law, regulation (specifically Regulation EU 2022/2065), or governmental request; to address fraud, security, or technical issues; or to protect Artetra&apos;s or Our partners&apos; rights.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h4">10. International Data Transfers</h2>
            <p>
              If personal data is transferred outside the EEA, Artetra ensures adequate safeguards such as Standard Contractual Clauses) in line with EU regulations.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h4">11. Updates to This Policy</h2>
            <p>
              We may update this Privacy Policy periodically. Updates will be published on our website, and continued use of the platform implies acceptance.
            </p>
          </section>

          <section>
            <h2 className="h4">12. Contact</h2>
            <p>If you have questions or concerns regarding this Privacy Policy, contact us at:</p>
            <p className="mb-1">Email: info@artetra.com</p>
            <p className="mb-0">
              Website: www.artetra.io ; www.museum-artetra.com
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
